import api from './api';

export interface UsageDaySnapshot {
  date: string;
  totalMinutes: number;
  sessionsCount: number;
}

export interface UsageSummaryResponse {
  days: UsageDaySnapshot[];
  totalMinutes: number;
  activeDays: number;
  streakDays: number;
}

export interface LogUsagePayload {
  sessionStart: string;
  sessionEnd?: string;
  durationSeconds?: number;
}

export const logUsageSession = async (payload: LogUsagePayload): Promise<void> => {
  await api.post('/usage/session', payload);
};

export const getUsageSummary = async (
  days = 7,
): Promise<UsageSummaryResponse> => {
  const response = await api.get('/usage/daily', { params: { days } });
  return response.data;
};

